// ============================================================
//  Qbrix Collections Overview — Page-specific JS
//  Requires: qbrix-theme.js (loaded before this file, provides brickSrc, BRAND_COLORS)
//  Contains: Dua Cara bitmaps, Orbit divider, Palette switcher,
//            Assembly Snap divider, Almazka style picker
// ============================================================

document.addEventListener('DOMContentLoaded', () => {
  if (!document.getElementById('dua-cara-grid')) return;

  // ── Helper: add class once element enters viewport ──────────
  function onceInView(el, className, threshold) {
    if (!el) return;
    const obs = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) { el.classList.add(className); obs.unobserve(el); }
    }, { threshold: threshold || 0.1 });
    obs.observe(el);
  }

  // ── Section headers B3: add hdr-in-view on scroll ──────────
  document.querySelectorAll('.hdr-observe').forEach(el => onceInView(el, 'hdr-in-view', 0.2));

  // ── buildBrickRow utility ───────────────────────────────────
  function buildBrickRow(id, palette, options) {
    const el = document.getElementById(id);
    if (!el || typeof brickSrc !== 'function') return;
    const size = (options && options.size) || 28;
    const bricks = palette.map(h => brickSrc(h));
    let containerWidth;
    if (options && options.useWindowWidth) {
      containerWidth = window.innerWidth;
    } else {
      let refEl = el, refW = 0;
      while (refEl && refW < 10) { refW = refEl.offsetWidth; refEl = refEl.parentElement; }
      containerWidth = refW || 512;
    }
    const targetWidth = containerWidth + size * 2;
    el.innerHTML = '';
    let totalW = 0, i = 0;
    while (totalW < targetWidth) {
      const img = document.createElement('img');
      img.src = bricks[i % bricks.length];
      img.width = size; img.height = size;
      img.className = 'pointer-events-none select-none';
      img.style.cssText = `width:${size}px;height:${size}px;display:block;flex-shrink:0;`;
      img.alt = '';
      el.appendChild(img);
      totalW += size;
      if (++i > 160) break;
    }
  }

  // ── Bitmap renderer for Dua Cara block ─────────────────────
  const BITMAP_DIGITS_3x5 = {
    '0':[1,1,1,1,0,1,1,0,1,1,0,1,1,1,1],
    '1':[0,1,0,1,1,0,0,1,0,0,1,0,1,1,1],
    '2':[1,1,1,0,0,1,1,1,1,1,0,0,1,1,1],
    '3':[1,1,1,0,0,1,0,1,1,0,0,1,1,1,1],
    '4':[1,0,1,1,0,1,1,1,1,0,0,1,0,0,1],
    '5':[1,1,1,1,0,0,1,1,1,0,0,1,1,1,1],
    '6':[1,1,1,1,0,0,1,1,1,1,0,1,1,1,1],
    '7':[1,1,1,0,0,1,0,1,0,0,1,0,0,1,0],
    '8':[1,1,1,1,0,1,1,1,1,1,0,1,1,1,1],
    '9':[1,1,1,1,0,1,1,1,1,0,0,1,1,1,1],
    '.':[0,0,0,0,0,0,0,0,0,0,0,0,0,1,0],
    ' ':[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
  };
  const BITMAP_CHARS_5x7 = {
    'A':[0,1,1,1,0,1,0,0,0,1,1,0,0,0,1,1,1,1,1,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1],
    'B':[1,1,1,1,0,1,0,0,0,1,1,0,0,0,1,1,1,1,1,0,1,0,0,0,1,1,0,0,0,1,1,1,1,1,0],
    '0':[0,1,1,1,0,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,1,0,1,1,1,0],
    '1':[0,0,1,0,0,0,1,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,1,1,1,0],
    '2':[0,1,1,1,0,1,0,0,0,1,0,0,0,0,1,0,0,1,1,0,0,1,0,0,0,1,0,0,0,0,1,1,1,1,1],
    '3':[1,1,1,1,0,0,0,0,0,1,0,0,0,0,1,0,1,1,1,0,0,0,0,0,1,0,0,0,0,1,1,1,1,1,0],
    '4':[0,0,0,1,1,0,0,1,0,1,0,1,0,0,1,1,0,0,0,1,1,1,1,1,1,0,0,0,0,1,0,0,0,0,1],
    '5':[1,1,1,1,1,1,0,0,0,0,1,0,0,0,0,1,1,1,1,0,0,0,0,0,1,0,0,0,0,1,1,1,1,1,0],
    '6':[0,1,1,1,0,1,0,0,0,0,1,0,0,0,0,1,1,1,1,0,1,0,0,0,1,1,0,0,0,1,0,1,1,1,0],
    '7':[1,1,1,1,1,0,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0],
    '8':[0,1,1,1,0,1,0,0,0,1,1,0,0,0,1,0,1,1,1,0,1,0,0,0,1,1,0,0,0,1,0,1,1,1,0],
    '9':[0,1,1,1,0,1,0,0,0,1,1,0,0,0,1,0,1,1,1,1,0,0,0,0,1,0,0,0,0,1,0,1,1,1,0],
    ' ':[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
  };

  // Brand colors — fallback if BRAND_COLORS not defined by qbrix-theme.js
  const _COLORS = (typeof BRAND_COLORS !== 'undefined') ? BRAND_COLORS : {
    yellow: '#F8C100', mint: '#B2D9C0', fuchsia: '#E02F85', cream: '#E0D9D5', white: '#ffffff'
  };
  const BITMAP_COLORS = {
    yellow: _COLORS.yellow, mint: _COLORS.mint, fuchsia: _COLORS.fuchsia,
    cream: _COLORS.cream, white: _COLORS.white
  };
  const BITMAP_OFF = 'rgba(255,255,255,0.06)';

  function renderBitmapDua(el) {
    const text = el.dataset.text || '';
    const colorKey = el.dataset.color || 'cream';
    const size = parseInt(el.dataset.computedSize) || parseInt(el.dataset.size) || 4;
    const type = el.dataset.computedType || el.dataset.type || 'digit';
    const gap = 1;
    const color = BITMAP_COLORS[colorKey] || _COLORS.cream;
    el.style.display = 'flex';
    el.style.alignItems = 'center';
    el.style.gap = `${size * 1.5}px`;
    el.style.flexWrap = 'nowrap';
    el.style.width = 'fit-content';
    el.style.maxWidth = '100%';
    el.innerHTML = '';
    text.split('').forEach(char => {
      const use5x7 = (type === 'letter');
      const dict = use5x7 ? BITMAP_CHARS_5x7 : BITMAP_DIGITS_3x5;
      const cols = use5x7 ? 5 : 3;
      const rows = use5x7 ? 7 : 5;
      const matrix = dict[char.toUpperCase()] || dict[' '];
      if (!matrix) return;
      const charEl = document.createElement('div');
      charEl.style.display = 'grid';
      charEl.style.gridTemplateColumns = `repeat(${cols}, ${size}px)`;
      charEl.style.gridTemplateRows = `repeat(${rows}, ${size}px)`;
      charEl.style.gap = `${gap}px`;
      charEl.style.flexShrink = '0';
      matrix.forEach(val => {
        const px = document.createElement('div');
        px.style.width = `${size}px`;
        px.style.height = `${size}px`;
        px.style.backgroundColor = val ? color : BITMAP_OFF;
        if (val) px.style.boxShadow = `0 0 3px ${color}44`;
        charEl.appendChild(px);
      });
      el.appendChild(charEl);
    });
  }

  const isMobile = () => window.innerWidth < 640;

  function computeBitmapSize(el) {
    const parent = el.parentElement;
    if (!parent) return parseInt(el.dataset.size) || 4;
    const parentW = parent.getBoundingClientRect().width - 24;
    if (parentW <= 0) return parseInt(el.dataset.size) || 4;
    const text = el.dataset.text || '';
    const type = el.dataset.type || 'digit';
    const use5x7Desktop = (type === 'digit' && !isMobile());
    const effectiveType = (type === 'letter' || use5x7Desktop) ? 'letter' : 'digit';
    const cols = effectiveType === 'letter' ? 5 : 3;
    const chars = text.length;
    if (chars === 0) return parseInt(el.dataset.size) || 4;
    const fillRatio = (effectiveType === 'digit') ? 1.0 : 0.95;
    const targetW = parentW * fillRatio;
    const s = (targetW - chars * (cols - 1)) / (chars * cols + (chars - 1) * 1.5);
    const maxSize = parseInt(el.dataset.size) || 4;
    return Math.max(2, Math.min(maxSize, Math.floor(s)));
  }

  function renderBitmapDuaAuto(el) {
    const size = computeBitmapSize(el);
    el.dataset.computedSize = size;
    const type = el.dataset.type || 'digit';
    const use5x7Desktop = (type === 'digit' && !isMobile());
    el.dataset.computedType = (use5x7Desktop) ? 'letter' : type;
    renderBitmapDua(el);
    el.style.marginLeft = '0';
    el.style.marginRight = '0';
  }

  function initBitmapDua() {
    const els = document.querySelectorAll('.bitmap-dua');
    if (typeof ResizeObserver !== 'undefined') {
      els.forEach(el => {
        const ro = new ResizeObserver(() => {
          renderBitmapDuaAuto(el);
          ro.disconnect();
        });
        ro.observe(el.parentElement || el);
      });
    } else {
      setTimeout(() => els.forEach(renderBitmapDuaAuto), 100);
    }
  }

  function syncBitmapHeights() {
    if (isMobile()) return;
    const container = document.getElementById('dua-cara-grid');
    if (!container) return;
    const bitmaps = container.querySelectorAll('.bitmap-dua');
    bitmaps.forEach(b => { b.style.minHeight = ''; });
    let maxH = 0;
    bitmaps.forEach(b => { const h = b.getBoundingClientRect().height; if (h > maxH) maxH = h; });
    if (maxH > 0) bitmaps.forEach(b => { b.style.minHeight = maxH + 'px'; });
  }

  initBitmapDua();
  setTimeout(syncBitmapHeights, 200);
  window.addEventListener('resize', () => {
    document.querySelectorAll('.bitmap-dua').forEach(renderBitmapDuaAuto);
    setTimeout(syncBitmapHeights, 100);
  });

  // ── Orbit Divider (after Block 1 / Dua Cara) ───────────────
  (function initDividerOrbit() {
    const container = document.getElementById('divider-v2-container');
    if (!container || typeof brickSrc !== 'function') return;
    const count = 14;
    const radiusX = Math.min(140, Math.floor(container.getBoundingClientRect().width / 2) - 20);
    const radiusY = 50;
    const ALL_BRICKS = ['e02f85','4a275d','1a2642','b2d9c0','f8c000','121212','f4f2e7','e793b7','fae8b8'];
    for (let i = 0; i < count; i++) {
      const img = document.createElement('img');
      img.src = brickSrc(ALL_BRICKS[i % ALL_BRICKS.length]);
      img.className = 'v2-brick pointer-events-none';
      img.style.width = '32px';
      img.style.height = '32px';
      img.alt = '';
      const angle = (i / count) * Math.PI * 2;
      const orbitX = `calc(50% + ${Math.cos(angle) * radiusX}px)`;
      const orbitY = `calc(50% + ${Math.sin(angle) * radiusY}px)`;
      const lineX  = `calc(50% + ${(i - count / 2 + 0.5) * 34}px)`;
      const rot    = (Math.random() * 180 - 90).toFixed(1);
      const delay  = (i % 3) * 100;
      img.style.setProperty('--orbit-x', orbitX);
      img.style.setProperty('--orbit-y', orbitY);
      img.style.setProperty('--line-x',  lineX);
      img.style.setProperty('--rot',     `${rot}deg`);
      img.style.setProperty('--delay',   `${delay}ms`);
      container.appendChild(img);
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.remove('divider-out');
          e.target.classList.add('divider-in');
        } else {
          e.target.classList.remove('divider-in');
          e.target.classList.add('divider-out');
        }
      });
    }, { threshold: 0.6 });
    obs.observe(container);
  })();

  // ── Palette Switcher — Fotokonstruktor (Block 2) ────────────
  (function initPaletteSwitcher() {
    const btns = document.querySelectorAll('.palette-btn');
    const preview = document.getElementById('palette-preview');
    const nameEl = document.getElementById('palette-name');
    if (!btns.length || !preview) return;
    const img = document.getElementById('palette-img');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const palette = btn.dataset.palette;
        if (img) {
          const src = img.dataset['src' + palette.charAt(0).toUpperCase() + palette.slice(1)];
          if (src) { img.src = src; img.alt = palette + ' palette'; }
        }
        if (nameEl) {
          const label = btn.querySelector('.palette-label');
          nameEl.textContent = label ? label.textContent : palette;
        }
      });
    });
    if (btns[0]) btns[0].click();
  })();

  // ── Assembly Snap Divider (after Block 2 / Fotokonstruktor) ─
  (function initV5Demo() {
    const slotsEl = document.getElementById('v5-demo-slots');
    const wrapEl = document.getElementById('v5-demo-wrap');
    if (!slotsEl || !wrapEl || typeof brickSrc !== 'function') return;

    const SNAP_PALETTE = ['e02f85', 'f8c000', 'b2d9c0', '4a275d', '1a2642', 'f4f2e7'];
    const COUNT = Math.min(7, Math.max(4, Math.floor(window.innerWidth / 60)));

    // Build slots
    for (let i = 0; i < COUNT; i++) {
      const slot = document.createElement('div');
      slot.className = 'v5-slot';
      const brickImg = document.createElement('img');
      brickImg.src = brickSrc(SNAP_PALETTE[i % SNAP_PALETTE.length]);
      brickImg.width = 32; brickImg.height = 32;
      brickImg.className = 'v5-brick-item pointer-events-none';
      brickImg.style.width = '32px';
      brickImg.style.height = '32px';
      brickImg.alt = '';
      slot.appendChild(brickImg);
      slotsEl.appendChild(slot);
    }

    let v5DemoTimer = null;
    const runV5Demo = () => {
      const items = slotsEl.querySelectorAll('.v5-brick-item');
      items.forEach(item => { item.classList.remove('is-placed'); });
      wrapEl.classList.remove('is-glowing');
      let idx = 0;
      if (v5DemoTimer) clearInterval(v5DemoTimer);
      v5DemoTimer = setInterval(() => {
        if (idx < items.length) {
          items[idx].classList.add('is-placed');
          idx++;
        } else {
          clearInterval(v5DemoTimer);
          wrapEl.classList.add('is-glowing');
          setTimeout(() => {
            wrapEl.classList.remove('is-glowing');
            setTimeout(runV5Demo, 600);
          }, 1200);
        }
      }, 180);
    };

    const obs = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) runV5Demo();
    }, { threshold: 0.6 });
    obs.observe(slotsEl);
  })();

  // ── Almazka Style Picker (Block 3) ─────────────────────────
  (function initAlmazkaStylePicker() {
    const btns = document.querySelectorAll('#almazka-picker .almazka-btn');
    const img = document.getElementById('almazka-img');
    if (!btns.length || !img) return;
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const style = btn.getAttribute('data-style');
        const src = img.getAttribute('data-src-' + style);
        if (src) img.src = src;
      });
    });
  })();

});
